import { Component } from 'san';
import { EType } from 'src/enums';
import { IData } from 'src/models';
import { TFun } from 'src/types';

const testType = EType.Detail;
const testFun: TFun = (type: EType) => {
    console.log('shared test lamda function', type);
}

export default class Shared extends Component {
    static filters = {
        json: (value) => {
            return JSON.stringify(value)
        }
    }

    constructor(option: any) {
        console.log('shared constructor', option)
        super(option);
    }

    initData(): IData {
        testFun(testType);
        return {
            name: 'Shared'
        };
    }

    inited() {
        console.log('shared inited params:', this.data.get('params'));
    }

    alert() {
        alert('shared alert')
    }
}